import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import OurStoryMain from "./OurStoryMain";
import Footer from "../../components/Footer";

const OurStory = () => {
  return (
    <>
      <HeaderFour />
      <OurStoryMain />
      <Footer />
    </>
  );
};

export default OurStory;
